import { defineComponent, ref } from 'vue'

import PointPage from '@/organizations/_default/point'
import PointSearchConditions from '@/components/common/PointSearchConditions.vue'
import ProductModal from '@/organizations/crecia/default/components/ProductModal.vue'

import { Filters } from '@/services/Filters.ts'


export default defineComponent({
  extends: PointPage,
  components: {
    PointSearchConditions,
    ProductModal
  },
  setup(props, context) {
    const page = PointPage.setup(props, context)

    // 選択した商品とその他の商品を分割するために利用
    const searchConditionsState = ref({
      isSelected: false,
      selectedIds: [],
      notSelectedIds: []
    })

    if (sessionStorage) {
      const cache = Filters.cache.load()
      const filterIds = cache?.search_conditions || []

      // 選択した商品とその他の商品を分割
      if (filterIds && filterIds.length > 0) {
        const ids = Filters.getPointFilters(
          Filters.TYPE_SEARCH_CONDITIONS,
          page.point.value,
          Filters.getFilterTree(Filters.TYPE_SEARCH_CONDITIONS)
        ).filter(c => c.is_show).map(c => c.id)

        if (ids.length > 0) {
          searchConditionsState.value.isSelected = true
          ids.forEach((id) => {
            if (filterIds.includes(id)) {
              searchConditionsState.value.selectedIds.push(id)
            } else {
              searchConditionsState.value.notSelectedIds.push(id)
            }
          })
        }
      }
    }

    const selectedProduct = ref({})
    const modalRef = ref(null)

    const onClickedSearchCondition = (searchCondition) => {
      selectedProduct.value = searchCondition
      modalRef.value.open()
    }

    return {
      ...page,
      selectedProduct,
      modalRef,
      searchConditionsState,
      onClickedSearchCondition
    }
  }
})
